<script>
    let className = '';
    export { className as class };
    export let sm = false;
    export let lg = false;
    export let xl = false;
    export let invert = false;
    export let tag = 'h2';
</script>

<svelte:element
    this={tag}
    class="font-extrabold text-balance leading-tight 
    {xl
        ? 'text-[1.875rem] md:text-[3rem]'
        : sm
        ? 'text-[1.25rem] leading-[1.4] md:text-[1.875rem] md:leading-[1.3333333]'
        : lg
        ? 'text-2xl md:text-4xl'
        : 'text-2xl md:text-3xl'}
    {invert ? 'text-symbols-invert-highlight' : 'text-symbols-highlight'}
    {className}"
>
    <slot />
</svelte:element>
